module.exports = __webpack_public_path__ + "static/media/linkedin-icon.314fb578.svg";